<template>
    <div
        class="flex w-full flex-col items-center justify-center gap-4 rounded border border-red-400 bg-red-125 p-8 text-center"
    >
        <div class="">
            <svg
                width="47"
                height="47"
                viewBox="0 0 47 47"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle
                    opacity="0.34"
                    cx="23.5"
                    cy="23.5"
                    r="23.5"
                    fill="#FBA89B"
                />
                <path
                    d="M24.0003 21.0009V24.7509M14.6973 28.1269C13.8313 29.6269 14.9143 31.5009 16.6453 31.5009H31.3553C33.0853 31.5009 34.1683 29.6269 33.3033 28.1269L25.9493 15.3789C25.0833 13.8789 22.9173 13.8789 22.0513 15.3789L14.6973 28.1269ZM24.0003 27.7509H24.0073V27.7589H24.0003V27.7509Z"
                    stroke="#E25941"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
        <div class="font-semibold text-red-500">Membership Expired</div>
        <div class="max-w-xl">
            <span v-if="!$page.props.auth.user.group_id">
                Your membership has expired, please enable auto renew below to
                re-activate your membership. You can cancel anytime.
            </span>
            <span v-else>
                Your membership has expired. To continue using EMTprep your
                instructor must add membership time to your account or you can
                sign up for a self-managed subscription.
                <div class="mt-4 flex justify-center">
                    <Link
                        :href="route('frontend.pricing')"
                        class="rounded bg-primary-525 px-3 py-2 text-white hover:cursor-pointer"
                    >
                        Add Subscription
                    </Link>
                </div>
                <!--                , if you-->
                <!--                would like to leave your group and manage your own subscription,-->
                <!--                select "Leave Group" below.-->
            </span>
        </div>
    </div>
</template>
<script>
export default {
    name: "StudentMembershipExpiredNotice",
};
</script>
